import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { qk } from '@/lib/query-client'
import type { ActivityWithActor } from '@/types/domain'

export function useActivity(entityId: string | null) {
  return useQuery({
    queryKey: qk.activity(entityId ?? 'none'),
    enabled: !!entityId,
    queryFn: async (): Promise<ActivityWithActor[]> => {
      const { data, error } = await supabase
        .from('activity_logs')
        .select('*, actor:profiles!activity_logs_actor_id_fkey(id,full_name,avatar_url,email)')
        .eq('entity_id', entityId!)
        .order('created_at', { ascending: false })
        .limit(50)
        .returns<ActivityWithActor[]>()
      if (error) throw error
      return data ?? []
    },
  })
}
